import { theme } from "styles/Theme"
const Required = () => {
    return <span style={{ color: `${theme.colors.crimson}` }}>*</span>
}

export default Required
